'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobDotValidation', cobDotValidation);

	cobDotValidation.$inject = [
		'$log', '$timeout', '$state', 'subjectObserverMessagesService', 'observerService', 'sessionService',
		'carrierRegistrationService', 'authenticationService'
	];

	var $log,
		$timeout,
		$state,
		subjectObserverMessagesService,
		observerService,
		sessionService,
		subjectMessages,
		observerMessages,
		carrierRegistrationService,
		authenticationService;

	function cobDotValidation(_$log_,
		_$timeout_,
		_$state_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_,
		_carrierRegistrationService_,
		_authenticationService_) {
		$log = _$log_;
		$timeout = _$timeout_;
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		sessionService = _sessionService_;
		carrierRegistrationService = _carrierRegistrationService_;
		authenticationService = _authenticationService_;

		return {
			restrict: 'E',
			scope: {
				visible: '='
			},
			replace: true,
			templateUrl: '/app/common/welcome/dotValidation.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.sessionService = sessionService;
			scope.m = {
				dotNumber: '',
				validationMessage: ''
			};

			scope.validateDot = validateDot;
			scope.setActiveSlide = setActiveSlide;
			scope.dotKeyPress = dotKeyPress;
			scope.authenticationService = authenticationService;

			registerObserverHandlers();

		}

		function registerObserverHandlers() {
		}

		function setActiveSlide(slide) {
			scope.m.validationMessage = '';
			scope.m.dotNumber = '';
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
				{
					setActiveSlide: slide,
					modalMessage: '',
					modalTitle: ''
				});
		}

		function validateDot() {
			scope.m.validationMessage = '';

			if (scope.m.dotNumber.length === 0) {
				scope.m.validationMessage = 'Valid input is required.';
			} else if (/^[0-9]{1,10}$/.test(scope.m.dotNumber) === false) {
				scope.m.validationMessage = 'The number provided does not match a valid DOT number. Please try again.';
			} else {
				setTimeout(function() {
					observerService
						.sendMessageToSubject(scope,
							subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				},
				1);

				carrierRegistrationService.validateDotNumber(scope.m.dotNumber)
					.then(function(response) {
						switch (response.data.validationInfo) {
						case 'Authorized':
							if (response.data.isMexico) {
								scope.m
									.validationMessage =
                                    'We are sorry, Mexico-based carriers are not supported by DAT OnBoard.';
								break;
							}

							if (response.data.carrierId === -1) {

								observerService.sendMessageToSubject(scope,
									subjectObserverMessagesService.getSubjectMessages()
										.COB_SUBJECT_CHANGE_WELCOME_VIEW,
									{
										setActiveSlide: 'confirmCompanySection',
										carrierList: response.data.carrierList,
										numberText: 'Number entered: ',
										searchNumber: scope.m.dotNumber,
										modalMessage: '',
										modalTitle: ''
									});

								scope.m.validationMessage = '';
								scope.m.dotNumber = '';
							} else //existing
							{
								observerService.sendMessageToSubject(scope,
									subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
									{
										modalMessage:
										'<br/><p><strong>The information provided matches an existing ' +
										'account. <a href="' + authenticationService.getLogoutUrl() + '">Please follow this link to log in</a>. ' +
										'You will be redirected to a new screen.</strong></p>',
										modalTitle: 'Account Found'
									});
							}
							break;
						case 'DOTNotFound':
							scope.m
								.validationMessage =
                                'The number provided does not match a valid DOT number. Please try again.';
							break;
						case 'DOTInactive':
							if (response.data.isMexico) {
								scope.m
									.validationMessage =
                                'We are sorry, Mexico-based carriers are not supported by DAT OnBoard.';
								break;
							}

							scope.m
								.validationMessage =
                                'The DOT number provided is not active. Only active carriers can register with DAT OnBoard.';
							break;
						case 'NoAuthority':
							if (response.data.isMexico) {
								scope.m
									.validationMessage =
                                'We are sorry, Mexico-based carriers are not supported by DAT OnBoard.';
								break;
							}
							scope.m
								.validationMessage =
                                'The DOT number provided belongs to a carrier with no active authority. Only carriers with active authority can register with DAT OnBoard.';
							break;
						}
					})
					.catch(function(e) {
						$log.error(e);
					})
					.finally(function() {
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			}

			return;
		}

		function dotKeyPress(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			if (charCode === 13) { // on Enter
				validateDot();
				event.preventDefault();

				return;
			}
			switch (charCode) {
			case 8: //backspace
			case 35: //end
			case 36: //home
			case 37: //left arrow
			case 39: //right arrow
			case 46: //delete
				return;
			}

			var key = String.fromCharCode(charCode);

			if (!/^[0-9]$/.test(key)) {
				event.preventDefault();
			}
		}
	}

})();
